import { z } from "zod";
import { Store } from "@storeLocator/storeType";
import STATES from "../storeLocator/shortApp/data/states";

const errorMessage = {
  required: "Please complete this required field to proceed",
  InvalidFormat: "Please check the format",
};

// export const schemaFirstStep = z.object({
//   FirstName: z.string().min(1, { message: errorMessage.required }),
//   LastName: z.string().min(1, { message: errorMessage.required }),
//   Email: z
//     .string()
//     .min(1, { message: errorMessage.required })
//     .email({ message: "Please enter a valid email address." }),
// });

export const schemaSecondStep = z.object({
  FirstName: z.string().min(1, { message: errorMessage.required }),
  LastName: z.string().min(1, { message: errorMessage.required }),
  Email: z
    .string()
    .min(1, { message: errorMessage.required })
    .email({ message: "Please enter a valid email address." }),
  CellPhone: z.string().min(14, { message: errorMessage.InvalidFormat }),
  HomeZipcode: z.string().min(5, { message: "Please enter 5 numbers" }),
});

// export interface FormValuesFirstStep {
//   [key: string]: string;
//   FirstName: string;
//   LastName: string;
//   Email: string;
// }
export interface FormValuesSecondStep {
  [key: string]: string;
  FirstName: string;
  LastName: string;
  Email: string;
  CellPhone: string;
  HomeZipcode: string;
}

export interface TimeFormValues {
  Time: Date;
  StoreLocation: Store;
}
export interface inputDataProps {
  fieldType?: "select" | "input";
  type?: "email" | "tel" | "text" | "hidden" | "password";
  name: string;
  placeholder?: string;
  optionData?: { name: string; abbr: string }[];
}

// export const inputDataFirstStep: inputDataProps[] = [
//   {
//     name: "FirstName",
//     placeholder: "First Name",
//   },
//   {
//     name: "LastName",
//     placeholder: "Last Name",
//   },
//   {
//     name: "Email",
//     placeholder: "Email",
//   },
// ];

export const inputDataSecondStep: inputDataProps[] = [
  {
    name: "FirstName",
    placeholder: "First Name",
  },
  {
    name: "LastName",
    placeholder: "Last Name",
  },
  {
    name: "Email",
    placeholder: "Email",
  },
  {
    type: "tel",
    name: "CellPhone",
    placeholder: "Cell Phone",
  },
  // {
  //   name: "Address",
  //   placeholder: "Address",
  // },
  {
    name: "HomeZipcode",
    placeholder: "Home Zipcode",
  },
  // { name: "City", placeholder: "City" },
  // {
  //   fieldType: "select",
  //   name: "State",
  //   placeholder: "State",
  //   optionData: STATES,
  // },
  // {
  //   name: "SSN",
  //   type: "password",
  //   placeholder: "Last 4 SSN",
  // },
];
